var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"badges"}},_vm._l((_vm.userData.badges),function(badge){return _c('img',{key:badge.name,staticClass:"badge",attrs:{"src":"/assets/badges/" + badge.name.toLowerCase() + ".png","alt":badge.name.toLowerCase()}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }